import { render, staticRenderFns } from "./SchoolLessonCard.vue?vue&type=template&id=6a14901a"
import script from "./SchoolLessonCard.vue?vue&type=script&lang=js"
export * from "./SchoolLessonCard.vue?vue&type=script&lang=js"
import style0 from "./SchoolLessonCard.vue?vue&type=style&index=0&id=6a14901a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports